import React, { useEffect, useState } from 'react';

import {
	Checkbox,
	FormControl,
	Input,
	ListItemText,
	MenuItem,
	Select,
	makeStyles,
	Button,
	Typography,
	Box,
	Divider,
	InputLabel,
	TextField,
	Menu,
	ButtonBase
} from '@material-ui/core';
import { ReactComponent as FilterIcon } from '../../assets/imgs/filter-icon.svg'
import { CheckBoxOutlineBlank, CheckBox as CheckboxIcon, ArrowDropDown } from '@material-ui/icons';
import { ReactComponent as ClassificationIcon } from '../../assets/imgs/sort-icon.svg';
import config from '../../config';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { challengeActions, curationActions } from '../../actions';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { uniqueId } from 'lodash';
import { ClassificationFilter } from './ClassificationFilter';

const filterOptions = createFilterOptions({
  limit: 100,
})

const useStyles = makeStyles((theme) => ({
	boxFormControl: {
		zIndex: 4,
		justifyContent: 'space-evenly',
		alignItems: 'center',
		minWidth: 123,
		minHeight: 56,
		backgroundColor: '#E9E9E9',
		borderRadius: 4,
		paddingRight: 10,
		paddingLeft: 10,
		marginRight: 16,
		paddingTop: 8,
		paddingBottom: 8,
	},
	filterButton: {
		color: theme.palette.neutrals.low.dark,
		backgroundColor: theme.palette.neutrals.high.light,
		'&:hover': {
			backgroundColor: theme.palette.neutrals.high.dark
		},
		fontSize: 14
	},

	count: {
		margin: '8px 16px',
		padding: '4px 8px',
		backgroundColor: theme.palette.neutrals.low.lightest,
		width: 23,
		height: 24,
		fontSize: 11,
		color: theme.palette.neutrals.low.dark,
		borderRadius: 4,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},

	select: {
		minWidth: 0,
	},
	icon: {
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	titleDropBox: { padding: 24, color: theme.palette.neutrals.low.light, fontSize: 14 }
}));

function CurationFilter({ list = false }) {
	const classes = useStyles();
	const [width] = useWindowSize();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { curation: { ideas, filters }, challenge: { challenges, paging: { sort, filter } }, domains: { occupationAreas } } = useSelector(state => state);
	const [optionsChallenge, setOptionsChallenge] = useState([]);
	const [optionsUnit, setOptionsUnit] = useState([]);
	const [optionsStatus, setOptionsStatus] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const [countFilters, setCountFilters] = useState(0);

	const statusCode = [
		{ id: uniqueId, value: 'CONCLUDED', label: t('concluida') },
		{ id: uniqueId, value: 'CANCELED', label: t('cancelada') },
		{
			id: uniqueId,
			value: 'AWAITING_QUALIFICATION',
			label: t('aguardado_qualificacao'),
		},
		{ id: uniqueId, value: 'UNQUALIFIED', label: t('nao_qualificado') },
		{ id: uniqueId, value: 'PATENT_PENDING', label: t('pendente_de_patente') },
		{ id: uniqueId, value: 'EXECUTION_QUEUE', label: t('fila_de_execucao') },
		{ id: uniqueId, value: 'EXECUTING', label: t('execucao') },
		{ id: uniqueId, value: 'QUALIFIED', label: t('qualificada') },
	];

	useEffect(() => {
		const countChallenge = optionsChallenge.filter(({ checked }) => checked === true).length
		const countUnit = optionsUnit.filter(({ checked }) => checked === true).length
		const countStatus = optionsStatus.filter(({ checked }) => checked === true).length

		setCountFilters(countChallenge + countUnit + countStatus);
	}, [optionsChallenge, optionsStatus, optionsUnit]);

	useEffect(() => {
		dispatch(challengeActions.getChallenges(1, sort, filter));
		const objsStatus = statusCode.map(({ label, value }) => ({
			label,
			value,
			checked: false
		}));
		setOptionsStatus(objsStatus);
	}, []);

	useEffect(() => {
		if (challenges) {
			const objsChallenge = challenges.map(({ name, _id }) => ({
				label: name,
				value: _id,
				checked: false
			}));
			setOptionsChallenge(objsChallenge);
		}
		if (occupationAreas) {
			const objsUnit = occupationAreas.map(({ name, _id }) => ({
				label: name,
				value: _id,
				checked: false
			}));
			setOptionsUnit(objsUnit);
		}
	}, [challenges, occupationAreas]);

	function handleClear() {
		dispatch(curationActions.clearFiltersNotStatus());
		handleClearFilters(optionsChallenge, setOptionsChallenge);
		handleClearFilters(optionsUnit, setOptionsUnit);
		handleClearFilters(optionsStatus, setOptionsStatus);
	};

	function handleClearFilters(name, filters, setter) {
		console.log(Array.isArray(filters))

		dispatch(curationActions.setFilters(name, []));
		if (!filters || filters.length<1 || !Array.isArray(filters) ) return;

		return setter(filters?.map(({ label, value }) => ({
			label,
			value,
			checked: false
		})));
	};

	function handleChallengeChange({ option }, options, setOptions) {
		const updated = options.map((item) => {
			if (item.value === option.value) {
				return {
					...item,
					checked: !item.checked
				}
			}
			return item;
		})
		setOptions(updated);
	};

	function handleChangeFilter(name, value) {
		dispatch(curationActions.setFilters(name, value));
	}

	function handleSendFilters() {
		dispatch(curationActions.filterIdeas(filters));
	}

	const handleOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (<>
		<ButtonBase
			onClick={handleOpen}
			className={classes.filterButton}
			width={countFilters > 0 ? 176 : 123}
		>
			<Box width="100%" display='flex' justifyContent="space-evenly" alignItems="center">
				{width > config.RESPONSIVE_MOBILE ? (
					<>
						<FilterIcon width="25%" />
						<Typography width="25%">{t('filtro')}</Typography>
					</>

				) : (<>
					<FilterIcon />
				</>
				)}
				{countFilters !== 0 && <span count={countFilters} className={classes.count}>{countFilters}</span>}
				<ArrowDropDown width="25%" />
			</Box>
		</ButtonBase>

		<Menu
			elevation={2}
			getContentAnchorEl={null}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			id="customized-menu"
			anchorEl={anchorEl}
			keepMounted
			open={Boolean(anchorEl)}
			onClose={handleClose}
		>
			<Typography className={classes.titleDropBox}>Filtrar por</Typography>
			<Divider />
			<Box style={{ padding: 24, display: 'flex', flexDirection: 'column' }}>
				{(list && <FormControl style={{ marginBottom: 30, width: 280 }}>
					<Autocomplete
						multiple
						disableCloseOnSelect
						id="checkboxes-status"
						options={optionsStatus}
						loading={optionsStatus.length === 0}
						getOptionLabel={(input) => input.label}
						value={optionsStatus.filter(item => item.checked === true)}
						onChange={(_e, value, reason, details) => {
							if (reason !== 'clear') {
								handleChallengeChange(details, optionsStatus, setOptionsStatus);
								const values = value.map(({ value }) => value);
								handleChangeFilter('statusCode', values)
							};

							if (reason === 'clear') handleClearFilters("statusCode", optionsStatus, setOptionsStatus);
						}}
						renderInput={(params) => (
							<TextField {...params} label="status" variant="filled" />
						)}
						renderTags={(option) => {
							return (<span>{option.length} {option.length > 1 ? "itens" : "item"} {option.length > 1 ? "selecionados" : "selecionado"}</span>)
						}}
						renderOption={(value) => (
							<li className={classes.flex}>
								<Checkbox
									color="primary"
									checked={value.checked === true}

								/>
								{value.label}
							</li>
						)}
					/>
				</FormControl>)}

				<FormControl style={{ marginBottom: 30, width: 280 }}>
					<Autocomplete
						multiple
						disableCloseOnSelect
						id="checkboxes-challenge"
						name="2"
						options={optionsChallenge}
						loading={optionsChallenge.length === 0}
						getOptionLabel={(input) => input.label}
						value={optionsChallenge.filter(item => item.checked === true)}
						onChange={(_e, value, reason, details) => {
							if (reason !== 'clear') {
								handleChallengeChange(details, optionsChallenge, setOptionsChallenge);
								const values = value.map(({ value }) => value);
								handleChangeFilter('challenges', values)
							};

							if (reason === 'clear') handleClearFilters("challenges", optionsChallenge, setOptionsChallenge);
						}}
						renderInput={(params) => (
							<TextField {...params} label="desafio" variant="filled" />
						)}
						renderTags={(option) => {
							return (<span>{option.length} {option.length > 1 ? "itens" : "item"} {option.length > 1 ? "selecionados" : "selecionado"}</span>)
						}}
						renderOption={(value) => (
							<li className={classes.flex}>
								<Checkbox
									color="primary"
									checked={value.checked === true}

								/>
								{value.label}
							</li>
						)}
					/>
				</FormControl>

				<FormControl style={{ marginBottom: 30, width: 280 }} >
					<Autocomplete
            filterOptions={filterOptions}
						multiple
						disableCloseOnSelect
						id="checkboxes-unit"
						options={optionsUnit}
						loading={optionsUnit.length === 0}
						getOptionLabel={(input) => input.label}
						value={optionsUnit.filter(item => item.checked === true)}
						onChange={(_e, value, reason, details) => {
							if (reason !== 'clear') {
								handleChallengeChange(details, optionsUnit, setOptionsUnit);
								const values = value.map(({ value }) => value);
								handleChangeFilter('occupationAreas', values);
							}

							if (reason === 'clear') handleClearFilters("occupationAreas", optionsUnit, setOptionsUnit);
						}}
						renderInput={(params) => (
							<TextField {...params} label={t('unidade_de_negocio')} variant="filled" />
						)}
						renderTags={(option) => {
							return (<span>{option.length} {option.length > 1 ? "itens" : "item"} {option.length > 1 ? "selecionados" : "selecionado"}</span>)
						}}
						renderOption={(value) => (
							<li className={classes.flex}>
								<Checkbox
									color="primary"
									checked={value.checked === true}

								/>
								{value.label}
							</li>
						)}
					/>
				</FormControl>
			</Box>

			<Box display='flex' justifyContent='end' style={{ padding: '0 24px 24px 0' }}>
				<Button
					color="primary"
					style={{ marginRight: 18 }}
					onClick={handleClear}
					variant="outlined">
					<Typography>{t('limpar_filtro')}</Typography>
				</Button>
				<Button
					color="primary"
					onClick={handleSendFilters}
					variant="contained">
					<FilterIcon style={{ fill: 'white' }} />
					<Typography>{t('filtrar')}</Typography>
				</Button>
			</Box>
		</Menu>
		<ClassificationFilter />
	</>);
}

export { CurationFilter };
